var exports = {
  "Qs": "AddConnectionModal.module__content___aEVmTE",
  "t$": "AddConnectionModal.module__stack___aEVmTE",
  "GA": "AddConnectionModal.module__instructions___aEVmTE",
  "G5": "AddConnectionModal.module__dnsCard___aEVmTE",
  "KJ": "AddConnectionModal.module__dnsHeading___aEVmTE",
  "Eq": "AddConnectionModal.module__dnsTitle___aEVmTE",
  "h_": "AddConnectionModal.module__dnsFields___aEVmTE",
  "ti": "AddConnectionModal.module__inlineCode___aEVmTE",
  "_c": "AddConnectionModal.module__dnsInput___aEVmTE",
  "x": "AddConnectionModal.module__orDivider___aEVmTE",
  "LC": "AddConnectionModal.module__orDividerLine___aEVmTE",
  "AS": "AddConnectionModal.module__orDividerText___aEVmTE",
  "iW": "AddConnectionModal.module__tokenCard___aEVmTE",
  "TN": "AddConnectionModal.module__tokenCardHeader___aEVmTE",
  "q6": "AddConnectionModal.module__tokenTitle___aEVmTE",
  "wc": "AddConnectionModal.module__tokenSubtitle___aEVmTE",
  "OB": "AddConnectionModal.module__tokenDownloadRow___aEVmTE",
  "RB": "AddConnectionModal.module__tokenMeta___aEVmTE",
  "cL": "AddConnectionModal.module__copyButton___aEVmTE",
  "nJ": "AddConnectionModal.module__copyIcon___aEVmTE",
};

module.exports = exports;
